module.exports = __webpack_public_path__ + "img/02.4c59bfee.png";